import React from "react";
import PropTypes from "prop-types";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/dist/styles.css";
import "yet-another-react-lightbox/dist/plugins/captions/captions.css";
import "yet-another-react-lightbox/dist/plugins/thumbnails/thumbnails.css";
import Captions from "yet-another-react-lightbox/dist/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/dist/plugins/fullscreen";
import Thumbnails from "yet-another-react-lightbox/dist/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/dist/plugins/zoom";
import Video from "yet-another-react-lightbox/dist/plugins/video";
import Download from "yet-another-react-lightbox/dist/plugins/download";
import moment from "moment/moment";
import {useTranslation} from "react-i18next";
import PdfPreview from "./Lightbox/PdfPreview";

export default function FilesLightbox(props) {
  const { t } = useTranslation('files');
  const [isOpen, setIsOpen] = React.useState(false);
  const [photoIndex, setPhotoIndex] = React.useState(0);

  React.useEffect(() => setIsOpen(props.isOpen), [props.isOpen]);
  React.useEffect(() => setPhotoIndex(props.photoIndex), [props.photoIndex]);

  if(!isOpen){
    return null;
  }

  const slides = props.files.map((file) => {
    let type = undefined;

    if (file.mimeType) {
      const mainType = file.mimeType.split("/")[0];

      if (["video"].includes(mainType)) {
        type = 'video';
      } else if (["image"].includes(mainType)) {
        type = mainType;
      } else if (file.mimeType === "application/pdf") {
        type = "pdf";
      } else {
        type = undefined;
      }
    }

    return {
      downloadUrl: file.fileUrl,
      downloadFilename: file.originalName,
      width: window.innerWidth,
      height: window.innerHeight,
      title: file.originalName,
      description: (<span>{t("date_created")}: {moment(file.createdAt).format("YYYY-MM-DD HH:mm")}</span>),
      src: file.fileUrl,
      type,
      sources: type === "video" ? [{src: file.fileUrl, type: 'video/mp4'}] : [],
    };
  });

  return (
    <Lightbox
      index={photoIndex}
      open={isOpen}
      close={() => {
        setIsOpen(false);
        props.onClose();
      }}
      slides={slides}
      plugins={[Captions, Thumbnails, Fullscreen, Video, Zoom, Download]}
      render={{
        slide: (slide) => {
          if (slide.slide.type === "pdf") {
            return (
              <div className="d-flex justify-content-center overflow-auto" style={{maxHeight: 'calc(100vh - 250px)'}}>
                <PdfPreview src={slide.slide.src}/>
              </div>
            );
          }
          return undefined;
        },
      }}
    />
  );
}

FilesLightbox.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  files: PropTypes.arrayOf(
    PropTypes.shape({
      fileUrl: PropTypes.string.isRequired,
      originalName: PropTypes.string.isRequired,
      mimeType: PropTypes.string,
      createdAt: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
};
